<template>
	<div class="brick view_brick2">
		<div class="view_inner">
			<form id="frm" method="POST" enctype="multipart/form-data">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr v-if="mode == 'detail'">
							<th>Select User</th>
							<td>
								<select v-model="selectedUserID" class="tbl_select sm_int" @change="userChanged()">
									<option v-for="user in allUsers" v-bind:value="user.user_id" v-bind:key="user.user_id">{{ user.user_id }} ({{ user.name }})</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>User ID</th>
							<td>
								<input type="text" v-model.trim="user.user_id" class="tbl_int sm_int" v-bind:readonly="mode == 'detail'" v-bind:disabled="mode == 'detail'" />
								<label for="admin_yn" style="margin-left:5px;"> <input type="checkbox" id="admin_yn" v-model="user.admin_yn" true-value="Y" false-value="N" v-bind:disabled="user.user_id == 'admin'" />Admin</label>
								<template v-if="user.upd_dt"> &nbsp;(Last updated : {{ user.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ user.upd_user }}, Created : {{ user.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ user.crt_user }}) </template>
								<template v-else> &nbsp;(Created : {{ user.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ user.crt_user }}) </template>
							</td>
						</tr>
						<tr>
							<th>Barcode</th>
							<td><input type="text" v-model.trim="user.barcode" class="tbl_int half_int" disabled="true" /></td>
						</tr>
						<tr>
							<th>Name</th>
							<td>
								<input type="text" v-model.trim="user.name" class="tbl_int sm_int" />
								<a v-if="mode == 'detail'" href="javascript:;" type="button" class="gray_bt" @click="openModal('ChangePassword')" style="margin-left:5px;">Change Password</a>
								{{ user.naked_password }}
							</td>
						</tr>
						<tr>
							<th>P. Permission</th>
							<td>
								<label for="cost_view_yn" style="margin-left:5px;"> <input type="checkbox" id="cost_view_yn" v-model="user.cost_view_yn" true-value="Y" false-value="N" />View Cost</label>
								<label for="price_adjust_yn" style="margin-left:15px;"> <input type="checkbox" id="price_adjust_yn" v-model="user.price_adjust_yn" true-value="Y" false-value="N" />Adjust Price</label>
								<label for="to_min_price_adjust_yn" style="margin-left:15px;">
									<input type="checkbox" id="to_min_price_adjust_yn" v-model="user.to_min_price_adjust_yn" true-value="Y" false-value="N" @change="toMinPriceAdjustChanged()" />Adjust to Min Price</label
								>
								<label for="to_lock_price_adjust_yn" style="margin-left:15px;">
									<input type="checkbox" id="to_lock_price_adjust_yn" v-model="user.to_lock_price_adjust_yn" true-value="Y" false-value="N" @change="toLockPriceAdjustChanged()" />Adjust to Lock Price</label
								>
								<label v-if="sessionUser.company_id == 'beautyplus'" for="lock_price_view" style="margin-left:15px;"> <input type="checkbox" id="lock_price_view" v-model="user.lock_price_view" />Lock Price View</label>
							</td>
						</tr>
						<tr>
							<th>SO/Inv. Permission</th>
							<td>
								<label for="so_approval" style="margin-left:5px;"> <input type="checkbox" id="so_approval" v-model="user.so_approval" />Approval</label>
								<label for="so_hold" style="margin-left:15px;"> <input type="checkbox" id="so_hold" v-model="user.so_hold" />Hold</label>
								<label for="so_void" style="margin-left:15px;"> <input type="checkbox" id="so_void" v-model="user.so_void" />SO Void</label>
								<label for="invoice_void" style="margin-left:15px;"> <input type="checkbox" id="invoice_void" v-model="user.invoice_void" />Invoice Void</label>
								<label for="so_imv" style="margin-left:15px;"> <input type="checkbox" id="so_imv" v-model="user.so_imv" />Import & Make Void</label>
								<label for="so_return" style="margin-left:15px;"> <input type="checkbox" id="so_return" v-model="user.so_return" />Return SO Entry</label>
								<label for="so_confirm" style="margin-left:15px;"> <input type="checkbox" id="so_confirm" v-model="user.so_confirm" />Return Confirm</label>
								<label for="complete_packing" style="margin-left:15px;"> <input type="checkbox" id="complete_packing" v-model="user.complete_packing" />Complete Packing</label>
							</td>
						</tr>
						<tr>
							<th>SO/Inv. Permission</th>
							<td>
								<label for="so_date_modifiable" style="margin-left:5px;"> <input type="checkbox" id="so_date_modifiable" v-model="user.so_date_modifiable" />SO Date Modifiable</label>
								<label for="approved_so_modifiable" style="margin-left:5px;"> <input type="checkbox" id="approved_so_modifiable" v-model="user.approved_so_modifiable" />Approved SO Modifiable</label>
								<label for="invoice_date_modifiable" style="margin-left:15px;"> <input type="checkbox" id="invoice_date_modifiable" v-model="user.invoice_date_modifiable" />Invoice Date Modifiable</label>
								<label for="ship_charge_modifiable" style="margin-left:5px;"> <input type="checkbox" id="ship_charge_modifiable" v-model="user.ship_charge_modifiable" />Ship Charge Modifiable</label>
								<label for="payment_term_modifiable" style="margin-left:15px;"> <input type="checkbox" id="payment_term_modifiable" v-model="user.payment_term_modifiable" />Payment Term Modifiable</label>
								<label for="margin_viewable" style="margin-left:15px;"> <input type="checkbox" id="margin_viewable" v-model="user.margin_viewable" />Margin Viewable</label>
							</td>
						</tr>
						<tr>
							<th>Item Permission</th>
							<td>
								<label for="icap_yn" style="margin-left:5px;"> <input type="checkbox" id="icap_yn" v-model="user.icap_yn" true-value="Y" false-value="N" />Item Change After Pick-Up</label>
								<label for="item_detail_view" style="margin-left:15px;"> <input type="checkbox" id="item_detail_view" v-model="user.item_detail_view" />Item Detail View</label>
							</td>
						</tr>
						<tr>
							<th :rowspan="sessionUser.company_id == 'hairplus' ? 3 : 2">ETC</th>
							<td>
								<label for="sc_confirm" style="margin-left:5px;"> <input type="checkbox" id="sc_confirm" v-model="user.sc_confirm" />Store Credit Confirm</label>
								<label for="po_price_view" style="margin-left:15px;"> <input type="checkbox" id="po_price_view" v-model="user.po_price_view" />PO Price & Vender Info Viewable</label>
								<label for="customer_only_view" style="margin-left:15px;"> <input type="checkbox" id="customer_only_view" v-model="user.customer_only_view" />Customer Only Viewable</label>
								<label for="preempted_so_view" style="margin-left:15px;"> <input type="checkbox" id="preempted_so_view" v-model="user.preempted_so_view" />Preempted SO Viewable</label>
								<label for="fob_price_view" style="margin-left:15px;"> <input type="checkbox" id="fob_price_view" v-model="user.fob_price_view" />FOB Price Viewable</label>
								<label for="color_code_mgmt" style="margin-left:15px;"> <input type="checkbox" id="color_code_mgmt" v-model="user.color_code_mgmt" />Color Code Mgmt.</label>
								<label for="icc_code_mgmt" style="margin-left:15px;"> <input type="checkbox" id="icc_code_mgmt" v-model="user.icc_code_mgmt" />Item {{ headers.class }} Code Mgmt.</label>
							</td>
						</tr>
						<tr>
							<td>
								<label for="box_adding" style="margin-left:5px;"> <input type="checkbox" id="box_adding" v-model="user.box_adding" />Add Empty Box(es)</label>
								<label for="image_mgmt_only" style="margin-left:15px;"> <input type="checkbox" id="image_mgmt_only" v-model="user.image_mgmt_only" />Image(Picture) Mgmt. Only</label>
								<label for="memo_mgmt" style="margin-left:15px;"> <input type="checkbox" id="memo_mgmt" v-model="user.memo_mgmt" />Partner Memo Mgmt.</label>
								<label v-if="profile.ship_address_control == 'Y'" for="ship_address_modifiable" style="margin-left:15px;"> <input type="checkbox" id="ship_address_modifiable" v-model="user.ship_address_modifiable" />Ship Address Modifiable</label>
								<label for="picking_ticket_print" style="margin-left:15px;"> <input type="checkbox" id="picking_ticket_print" v-model="user.picking_ticket_print" />Picking Ticket Print</label>
								<label for="sample_approval" style="margin-left:15px;"> <input type="checkbox" id="sample_approval" v-model="user.sample_approval" />Sample Approval</label>
								<label for="notice_management" style="margin-left:15px;"> <input type="checkbox" id="notice_management" v-model="user.notice_management" />Notice Management</label>
								<label for="warehouse_printer" style="margin-left:15px;"> <input type="checkbox" id="warehouse_printer" v-model="user.warehouse_printer" />Warehouse Printer</label>
								<label v-if="sessionUser.company_id == 'hairplus'" for="ar_memo_mgmt" style="margin-left:15px;"> <input type="checkbox" id="ar_memo_mgmt" v-model="user.ar_memo_mgmt" />AR Memo</label>
							</td>
						</tr>
						<tr v-if="sessionUser.company_id == 'hairplus'">
							<td>
								<label for="view_receipt_remark" style="margin-left:5px;"> <input type="checkbox" id="view_receipt_remark" v-model="user.view_receipt_remark" />View Receipt Remark</label>
							</td>
						</tr>
						<template v-if="mode == 'add'">
							<tr>
								<th>Password</th>
								<td><input type="password" v-model.trim="user.password" class="tbl_int sm_int" /></td>
							</tr>
							<tr>
								<th>Confirm</th>
								<td><input type="password" v-model.trim="user.password_confirm" class="tbl_int sm_int" /></td>
							</tr>
						</template>
						<tr>
							<th>User Type</th>
							<td>
								<select id="dlUserType" v-model="user.user_type" class="tbl_select sm_int" v-bind:disabled="user.user_id == 'admin'" @change="userTypeChanged()">
									<option v-for="userType in this.$userTypes" v-bind:value="userType.value" v-bind:key="userType.value">{{ userType.text }}</option>
								</select>
								<label for="partner_export_print" style="margin-left:15px;"> <input type="checkbox" id="partner_export_print" v-model="user.partner_export_print" />Partner Print & Export</label>
								<!-- {{ user.upd_dt | moment('timezone', $session.get('time_zone'), 'YYYY-MM-DD HH:mm:ss') }} -->
							</td>
						</tr>
						<tr>
							<th>Department</th>
							<td>
								<select v-model="user.dept_code" class="tbl_select sm_int">
									<option v-for="dept in depts" v-bind:value="dept.code" v-bind:key="dept.cpde">{{ dept.name }}</option>
								</select>
								<!-- {{ user.upd_dt | moment('timezone', $session.get('time_zone'), 'YYYY-MM-DD HH:mm:ss') }} -->
							</td>
						</tr>
						<tr>
							<th>Sales Team</th>
							<td>
								<select v-model="user.sales_team_code" class="tbl_select sm_int" v-bind:disabled="false && user.user_type != 'salesman'">
									<option :value="null"></option>
									<option v-for="salesTeam in salesTeams" v-bind:value="salesTeam.code" v-bind:key="salesTeam.cpde">{{ salesTeam.name }}</option>
								</select>
								<!-- {{ user.upd_dt | moment('timezone', $session.get('time_zone'), 'YYYY-MM-DD HH:mm:ss') }} -->
							</td>
						</tr>
						<tr>
							<th>Employee No</th>
							<td><input type="text" v-model.trim="user.employee_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr v-if="hireResignEnabled && mode == 'detail'">
							<th>Hire Date</th>
							<td><CustomDatePicker v-model="user.hire_date" /></td>
						</tr>
						<tr v-if="hireResignEnabled && mode == 'detail'">
							<th>Resign Date</th>
							<td><CustomDatePicker v-model="user.resign_date" /></td>
						</tr>
						<tr>
							<th>Position</th>
							<td><input type="text" v-model.trim="user.position" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Phone No</th>
							<td><input type="text" v-model.trim="user.phone_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Email</th>
							<td><input type="text" v-model.trim="user.email" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Base Salary</th>
							<td><currency-input type="text" v-model.trim="user.salary" class="tbl_int sm_int al_right" /></td>
						</tr>
						<tr>
							<th>Hourly Salary</th>
							<td><currency-input type="text" v-model.trim="user.salary_h" class="tbl_int sm_int al_right" /></td>
						</tr>
						<tr>
							<th>Commission Rate</th>
							<td><currency-input type="text" v-model.trim="user.commission_rate" class="tbl_int sm_int al_right" />&nbsp;%</td>
						</tr>
						<tr>
							<th>Social #</th>
							<td><input type="text" v-model.trim="user.social_no" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>Address</th>
							<td colspan="4">
								<input class="tbl_int half_int" type="text" id="address_detail" v-model.trim="user.address_detail" />
								<a href="javascript:;" class="gray_bt" @click="clearAddress()" style="margin-left:5px;">Clear</a>
							</td>
						</tr>
						<tr>
							<th>City</th>
							<td>
								<input type="text" id="address_city" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="user.address_city" />
								<input type="text" class="tbl_int sm_int" id="address_state" placeholder="NY" v-model.trim="user.address_state" style="margin-left:5px;" />
								<input type="text" class="tbl_int ssm_int" id="address_zipcode" placeholder="10029" v-model.trim="user.address_zipcode" style="margin-left:5px;" />
								<a href="#" class="gray_bt" id="map" type="button" style="margin-left:5px;" @click="openModal('GoogleMap')">Map</a>
							</td>
						</tr>
						<tr>
							<th></th>
							<td>
								<label for="operate_yn" style="margin-left:5px;"> <input type="checkbox" id="operate_yn" v-model="user.operate_yn" true-value="Y" false-value="N" v-bind:disabled="user.user_id == 'admin'" />Operating User</label>
								<label for="gps_yn" style="margin-left:20px;"> <input type="checkbox" id="gps_yn" v-model="user.gps_yn" true-value="Y" false-value="N" v-bind:disabled="user.user_id == 'admin'" />GPS Log Collect </label>
								<label for="login_id_scan" style="margin-left:20px;"> <input type="checkbox" id="login_id_scan" v-model="user.login_id_scan" />Login ID Scan </label>

								<label for="active_yn" style="margin-left:100px;"> <input type="checkbox" id="active_yn" v-model="user.active_yn" true-value="Y" false-value="N" v-bind:disabled="user.user_id == 'admin'" />Active</label>
								<label for="temp_flag" style="margin-left:100px;" v-if="sessionUser.admin_yn == 'Y'"> <input type="checkbox" id="temp_flag" v-model="user.temp_flag" />Temp Flag</label>
							</td>
						</tr>
						<tr v-if="mode == 'detail'">
							<th>Lock Count</th>
							<td>
								<!-- <money type="text" v-model.trim="user.lock_count" class="tbl_int sm_int al_right" /> -->
								<currency-input type="text" v-model.trim="user.lock_count" :precision="0" :allow-negative="false" class="tbl_int sm_int al_right" />
							</td>
						</tr>
						<tr>
							<th>Time Zone</th>
							<td>
								<select v-model="user.time_zone" class="tbl_select mm_int">
									<option v-for="timeZone in this.$timeZones" v-bind:value="timeZone" v-bind:key="timeZone">{{ timeZone }}</option>
								</select>
								<a href="javascript:;" class="gray_bt" @click="clearTimeZone()" style="margin-left:5px;">Clear</a>
								<!-- <input type="text" v-model.trim="user.time_zone" class="tbl_int mm_int" /> -->
							</td>
						</tr>
						<tr>
							<th>Description</th>
							<td><textarea v-model.trim="user.description" class="tbl_int" style="height: 40px;" /></td>
						</tr>
						<!-- <tr id="trAccess" style="display:<#if user?? && user.admin_yn == 'Y'>none<#else>display</#if>;"> -->
						<tr>
							<th></th>
							<td></td>
						</tr>
						<tr>
							<th>Default Menu</th>
							<td>
								<select v-model="user.home_path" class="tbl_select sm_int">
									<option value="null">Notice (Default)</option>
									<option v-for="menu in validMenus" v-bind:value="menu.path" v-bind:key="menu.path">{{ menu.gnb_name }} - {{ menu.name }}</option>
								</select>
							</td>
						</tr>
						<tr v-if="user.admin_yn == 'N'" style="margin-top:10px;">
							<!-- <th valign="top">Access Control</th> -->
							<td class="al_right">From</td>
							<td>
								<!-- <UserAccess :user_id="user.user_id" /> -->
								<!-- <div id="div_access" style="width:700px"></div> -->
								<select v-model="toCopyUserID" class="tbl_select sm_int ">
									<option v-for="user in allUsers" v-bind:value="user.user_id" v-bind:key="user.user_id">{{ user.user_id }} ({{ user.name }})</option>
								</select>
								<a href="javascript:;" type="button" class="gray_bt mgr_15" @click="copyPermission()">Copy Permissions & Menus</a>
							</td>
						</tr>
						<!-- <th></th>
						<td><a href="javascript:;" type="button" class="gray_bt" @click="openModal('Test')">Test</a></td> -->
					</tbody>
				</table>

				<br />

				<div class="view_bottom_bt">
					<a href="javascript:;" type="button" class="search_bt" @click="submit(false)">Save & Return To Previous Page</a>
					<a href="javascript:;" type="button" class="search_bt" @click="submit(true)">Save Only</a>
					<a v-if="false" href="javascript:;" type="button" :disabled="isErasable" :class="!isErasable ? 'disable_bt' : 'gray_bt'" @click="delUser()" class="delete_button">Delete</a>
					<!-- <a href="javascript:;" type="button" <#if "${mode}" == "add" || "${user.user_id}" == "admin">class="disable_bt" <#else> id="delete" class="gray_bt" </#if>>Delete</a>	 -->
				</div>

				<table v-if="user.admin_yn == 'N'" class="list_tbl" border="0" style="width:700px;padding-top:10px;">
					<thead>
						<tr>
							<th style="text-align:center;">GNB Name</th>
							<th style="text-align:center;">Menu</th>
							<th style="text-align:center;"><input type="checkbox" @change="viewAll()" v-model="allView" />&nbsp;View</th>
							<th style="text-align:center;"><input type="checkbox" @change="modifyAll()" v-model="allModify" />&nbsp;Modify</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="menu in menus" v-bind:key="menu.path">
							<td class="al_left">{{ menu.gnb_name }}</td>
							<td class="al_left">{{ menu.name }}</td>
							<td class="al_center">
								<input type="checkbox" v-model="menu.view_yn" true-value="Y" false-value="N" />
							</td>
							<td class="al_center">
								<input type="checkbox" v-model="menu.modify_yn" true-value="Y" false-value="N" />
							</td>
						</tr>
					</tbody>
				</table>
			</form>
		</div>
		<Modal @close="closeModal" v-if="showModal && modalName == 'ChangePassword'" :draggable="false">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Change Password</template>
			<template slot="body">
				<ChangePassword :user_id="user.user_id" v-on:close="closeModal" />
			</template>
		</Modal>
		<Modal v-if="showModal && modalName == 'HireResignDate'" :draggable="false" :showCloseButton="false">
			<template slot="title">{{ date_prompt.title }}</template>
			<template slot="body">
				<div style="padding:10px;">
					<p style="margin-bottom:10px;">{{ date_prompt.message }}</p>
					<CustomDatePicker v-model="date_prompt.value" />
					<div class="view_bottom_bt" style="margin-top:15px;">
						<a href="javascript:;" type="button" class="search_bt" @click="closeDatePrompt(true)">OK</a>
						<a href="javascript:;" type="button" class="gray_bt" @click="closeDatePrompt(false)">Skip</a>
					</div>
				</div>
			</template>
		</Modal>
		<Modal @close="closeModal" v-if="showModal && modalName == 'GoogleMap'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Select Location</template>
			<template slot="body">
				<GoogleMap :initialLocation="location" v-on:updateLocation="updateLocation" v-on:close="closeModal()" />
			</template>
		</Modal>
		<!-- <Modal @close="closeModal" v-if="showModal && modalName == 'Test'">
			<template slot="title">Other</template>
			<template slot="body">
				<OtherModal v-on:close="closeModal()" />
			</template>
		</Modal> -->
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectUser, apiInsertUser, apiUpdateUser, apiDeleteUser, apiSelectUserList } from '@/api/basicinfo/user.js';
import { apiSelectCodeList } from '@/api/basicinfo/code.js';
import Modal from '@/components/common/Modal';
import ChangePassword from '@/components/common/ChangePassword';
import GoogleMap from '@/components/common/GoogleMap';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { today } from '@/utils/date.js';
//import UserAccess from '@/components/basicinformation/UserAccess';
// import OtherModal from '@/components/common/OtherModal';

export default {
	data: function() {
		return {
			backUri: '/basic_info/user',
			mode: 'add',
			user: { admin_yn: 'N' },
			depts: [],
			salesTeams: [],

			menus: [],

			allUsers: [],
			selectedUserID: null,
			toCopyUserID: null,

			// userTypes: [
			// 	{ value: 'staff', text: 'Office' },
			// 	{ value: 'salesman', text: 'Salesman' },
			// 	{ value: 'driver', text: 'Driver' },
			// 	{ value: 'whstaff', text: 'Warehouse Staff' },
			// ],

			allView: false,
			allModify: false,

			modalName: '',
			showModal: false,

			// ZD-3281 : 입사일·퇴사일 최초 1회 입력
			prev_active_yn: null,
			submitting: false,
			date_prompt: { field: '', title: '', message: '', value: null, stay: false },
		};
	},
	props: ['headers'],
	computed: {
		isErasable() {
			return this.mode == 'add' || this.user.user_id != 'admin' ? false : true;
			// if (this.mode == 'add' || this.user.user_id == 'admin') return false;
			// else return true;
		},
		location() {
			return {
				lat: this.user.lat,
				lng: this.user.lng,
				//place_id: this.user.place_id,
				address_detail: this.user.address_detail,
				address_city: this.user.address_city,
				address_state: this.user.address_state,
				address_zipcode: this.user.address_zipcode,
				country: this.user.country,
			};
		},
		validMenus() {
			return this.menus.filter(m => m.view_yn == 'Y');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		sessionUser: function() {
			return this.$session.get('user');
		},
		// ZD-3281 : 입사일·퇴사일은 beautyplus 에서만 노출·동작한다.
		hireResignEnabled: function() {
			return this.sessionUser && this.sessionUser.company_id == 'beautyplus';
		},
	},
	components: {
		ChangePassword,
		GoogleMap,
		Modal,
		CustomDatePicker,
		//UserAccess,
	},
	methods: {
		async copyPermission() {
			if (!this.toCopyUserID) {
				this.$toast.error('Select user');
				return;
			}
			//var toCopyUser =
			const { data } = await apiSelectUser({
				user_id: this.toCopyUserID,
			});

			//this.user = data.user;
			if (data.user) {
				this.user.cost_view_yn = data.user.cost_view_yn;
				this.user.price_adjust_yn = data.user.price_adjust_yn;
				this.user.to_min_price_adjust_yn = data.user.to_min_price_adjust_yn;
				this.user.to_lock_price_adjust_yn = data.user.to_lock_price_adjust_yn;
				this.user.so_approval = data.user.so_approval;
				this.user.so_hold = data.user.so_hold;
				this.user.so_void = data.user.so_void;
				this.user.so_imv = data.user.so_imv;
				this.user.so_confirm = data.user.so_confirm;
				this.user.so_return = data.user.so_return;
				this.user.icap_yn = data.user.icap_yn;
				this.user.so_date_modifiable = data.user.so_date_modifiable;
				this.user.invoice_date_modifiable = data.user.invoice_date_modifiable;
				this.user.ship_charge_modifiable = data.user.ship_charge_modifiable;
				this.user.payment_term_modifiable = data.user.payment_term_modifiable;
				this.user.approved_so_modifiable = data.user.approved_so_modifiable;
				this.user.complete_packing = data.user.complete_packing;
				this.user.partner_export_print = data.user.partner_export_print;
				this.user.margin_viewable = data.user.margin_viewable;
				this.user.item_detail_view = data.user.item_detail_view;
				this.user.sc_confirm = data.user.sc_confirm;
				this.user.po_price_view = data.user.po_price_view;
				this.user.customer_only_view = data.user.customer_only_view;
				this.user.preempted_so_view = data.user.preempted_so_view;
				this.user.fob_price_view = data.user.fob_price_view;
				this.user.lock_price_view = data.user.lock_price_view;
				this.user.color_code_mgmt = data.user.color_code_mgmt;
				this.user.memo_mgmt = data.user.memo_mgmt;
				this.user.box_adding = data.user.box_adding;
				this.user.notice_management = data.user.notice_management;
				this.user.sample_approval = data.user.sample_approval;
				this.user.warehouse_printer = data.user.warehouse_printer;
				this.user.ar_memo_mgmt = data.user.ar_memo_mgmt;
				this.user.view_receipt_remark = data.user.view_receipt_remark;

				this.menus = data.menuList;
			} else {
				this.$toast.error('User not found');
			}
		},
		viewAll() {
			var vm = this;
			this.menus.forEach(function(menu) {
				menu.view_yn = vm.allView ? 'Y' : 'N';
			});
		},
		modifyAll() {
			var vm = this;
			this.menus.forEach(function(menu) {
				menu.modify_yn = vm.allModify ? 'Y' : 'N';
			});
		},
		toMinPriceAdjustChanged() {
			if (this.user.to_min_price_adjust_yn == 'Y') {
				this.user.price_adjust_yn = 'Y';
			}
		},
		toLockPriceAdjustChanged() {
			if (this.user.to_lock_price_adjust_yn == 'Y') {
				this.user.price_adjust_yn = 'Y';
				this.user.to_min_price_adjust_yn = 'Y';
			}
		},
		userTypeChanged() {
			//console.log(this.user.user_type);
			if (this.user.user_type != 'salesman') {
				this.user.sales_team_code = null;
			}
		},
		userChanged() {
			//console.log(this.selectedUserID);
			this.user.user_id = this.selectedUserID;
			this.selectUser();
		},
		async selectDepts() {
			const { data } = await apiSelectCodeList({
				code_type: 'DP', //Department
				active_yn: 'Y',
			});

			//console.log(data);
			this.depts = data.codeList;
		},
		async selectSalesTeams() {
			const { data } = await apiSelectCodeList({
				code_type: 'ST', //Sales Team
				active_yn: 'Y',
			});
			this.salesTeams = data.codeList;
		},
		async selectUser() {
			const { data } = await apiSelectUser({
				user_id: this.user.user_id,
			});

			this.user = data.user;
			this.menus = data.menuList;
			// ZD-3281 : Y->N 최초 1회 판정 기준. 조회로 확정된 값만 사용한다.
			this.prev_active_yn = data.user ? data.user.active_yn : null;
			//this.allUsers = data.allUsers;
			//console.log(this.allUsers);
			//console.log(this.menus);
		},
		async submit(stay) {
			if (this.submitting) return;
			if (!this.user.user_id) {
				this.$toast.error('User ID is empty');
				return;
			}

			// ZD-3281 : 저장 직전 최초 1회만 날짜를 물어본다. beautyplus 가 아니면 판정하지 않는다.
			if (this.hireResignEnabled) {
				if (this.mode == 'add') {
					this.openDatePrompt('hire_date', 'Hire Date', 'Enter the hire date of this user.', stay);
					return;
				}
				if (this.prev_active_yn == 'Y' && this.user.active_yn == 'N' && !this.user.resign_date) {
					this.openDatePrompt('resign_date', 'Resign Date', 'Enter the resign date of this user.', stay);
					return;
				}
			}

			await this.saveUser(stay);
		},
		openDatePrompt(field, title, message, stay) {
			this.date_prompt = { field: field, title: title, message: message, value: today(), stay: stay };
			this.openModal('HireResignDate');
		},
		async closeDatePrompt(apply) {
			const field = this.date_prompt.field;
			const stay = this.date_prompt.stay;
			// Skip 이면 날짜를 비운 채 저장을 그대로 진행한다.
			this.$set(this.user, field, apply ? this.date_prompt.value : null);

			this.showModal = false;
			this.modalName = '';
			this.date_prompt = { field: '', title: '', message: '', value: null, stay: false };

			await this.saveUser(stay);
		},
		async saveUser(stay) {
			this.submitting = true;
			try {
				if (this.user.admin_yn == 'Y') this.user.menus = [];
				else this.user.menus = this.menus;

				if (this.validMenus.filter(m => m.path == this.user.home_path).length == 0) this.user.home_path = null;

				var response;
				if (this.mode == 'add') {
					response = await apiInsertUser(this.user);
				} else {
					response = await apiUpdateUser(this.user);
				}
				var data = response.data;

				if (data.result) {
					this.$toast.success('Saved successfully');
					//console.log(this.backUri);
					if (!stay) {
						this.$router.push(this.backUri);
					} else {
						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Basic Information -> User -> Detail');
						await this.selectUser();
					}
				} else {
					this.$toast.error(data.msg);
				}
			} finally {
				// 실패·예외에도 반드시 해제해 재시도가 가능하게 한다.
				this.submitting = false;
			}
		},
		async delUser() {
			if (!this.isErasable) return;
			if (confirm('Are you sure to delete the user?')) {
				const { data } = await apiDeleteUser(this.user);

				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.$router.push(this.backUri);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(returnValue, param) {
			//console.log(returnValue);
			if (this.modalName == 'ChangePassword' && returnValue) {
				//console.log(param);
				this.user.naked_password = param;
			}
			this.showModal = false;
		},
		clearAddress() {
			this.user.address_detail = '';
			this.user.address_city = '';
			this.user.address_state = '';
			this.user.address_zipcode = '';
			this.user.country = '';
		},
		clearTimeZone() {
			this.user.time_zone = null;
		},
		updateLocation: function(location) {
			if (location.lat) this.user.lat = location.lat;
			if (location.lng) this.user.lng = location.lng;
			if (location.place_id) this.user.place_id = location.place_id;
			if (location.address_detail && !this.user.address_detail) this.user.address_detail = location.address_detail;
			if (location.address_city && !this.user.address_city) this.user.address_city = location.address_city;
			if (location.address_state && !this.user.address_state) this.user.address_state = location.address_state;
			if (location.address_zipcode && !this.user.address_zipcode) this.user.address_zipcode = location.address_zipcode;
			if (location.country && !this.user.country) this.user.country = location.country;

			//console.log(location);
			//this.user.place_id = placeId;
			//console.log('event received');
			//console.log(this.user);
		},
		async selectAllUser() {
			const { data } = await apiSelectUserList({
				paging_yn: 'N',
				active_yn: 'Y',
			});

			this.allUsers = data.userList;
		},
	},
	created() {
		this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		//this.$store.selectedMenu = 'nav_li_25';
		this.$store.commit('setSelectedMenu', 'nav_li_25');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Basic Information -> User -> Add');

			this.user.price_adjust_yn = 'Y';
		} else {
			this.$store.commit('setSubTitle', 'Basic Information -> User -> Detail');
			this.user.user_id = this.$route.query.user_id;
			this.selectUser();
		}

		this.selectAllUser();
		this.selectDepts();
		this.selectSalesTeams();

		//console.log(this.$moment.tz.getDefault());

		//console.log(this.isErasable);
		//var vm = this;
		//vm.selectUsers();
		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
